import { tt } from '@agos/shared'

/**
 * What the invoicing screens' main-administrator writes ask - `FRONTEND.md` §9.758, `BACKEND.md` §10A.413 (owner,
 * folded into O119).
 *
 * <p><b>Opened to a right.</b> A standing charge's create, edit and *Vygenerovať* (`POST`/`PATCH /recurring-invoices`,
 * `POST /recurring-invoices/run`) ask `recurring_invoices_edit`, and its delete `recurring_invoices_delete` - the
 * write keys alone, because `recurring_invoices`, the screen's own key, is held by Nesvady's *Čašník*. *Opakované
 * faktúry* offered all four to every visitor; the server refused them to everybody but the main administrator.
 *
 * <p><b>Kept with the main administrator, and gated to them here.</b> The bank connection - `GET` and `PATCH
 * /tatrabanka/settings` and `POST /tatrabanka/run-scheduler` - holds the credentials and decides where money goes, so
 * §10A.413 keeps it. *Bankové spojenie* offered its save and *Spustiť plánovač teraz* to everybody the route admits.
 * Invoice approval stays the main administrator's too (the four-eyes check on administrators) and is untouched.
 */
export const RECURRING_INVOICES_EDIT = 'recurring_invoices_edit'
export const RECURRING_INVOICES_DELETE = 'recurring_invoices_delete'

/** Which of a standing charge's writes this person is offered. */
export interface RecurringActions {
  /** *Nová šablóna*, *Upraviť* and *Spustiť generovanie* - the create, the edit and the run. */
  edit: boolean
  /** *Zmazať* on a template. */
  delete: boolean
}

export function recurringActionsFor(hasPermission: (permission: string) => boolean): RecurringActions {
  return { edit: hasPermission(RECURRING_INVOICES_EDIT), delete: hasPermission(RECURRING_INVOICES_DELETE) }
}

/** Said under *Opakované faktúry*'s header when something it used to offer is not offered - the rights, by label. */
export function recurringReadOnlyNote(actions: RecurringActions): string | null {
  const edit = `„${tt('Opakované faktúry - Upraviť')}“`
  const remove = `„${tt('Opakované faktúry - Zmazať')}“`
  if (!actions.edit && !actions.delete) {
    return `${tt('Šablóny tu len vidíte - pridať, upraviť, vygenerovať z nich faktúry a zmazať ich môže ten, kto má práva')} ${edit} ${tt('a')} ${remove}.`
  }
  if (!actions.edit) {
    return `${tt('Pridať, upraviť a vygenerovať faktúry zo šablón môže len ten, kto má právo')} ${edit}.`
  }
  if (!actions.delete) return `${tt('Zmazať šablónu môže len ten, kto má právo')} ${remove}.`
  return null
}

/** The one role that manages the bank connection - `TatrabankaController`'s three handlers, kept by §10A.413. */
export const BANK_MANAGER_ROLE = 'main_admin'

export function managesBank(systemRole: string | undefined): boolean {
  return systemRole === BANK_MANAGER_ROLE
}

/** Said on *Bankové spojenie* to anybody else, in place of a form whose read the server refuses them. */
export function bankNote(): string {
  return tt(
    'Bankové spojenie - prístupové údaje k banke a plánovač automatických platieb - spravuje len hlavný administrátor.',
  )
}
